import {Calculation} from '../../models/api/calculation.model';
import {RegisterCalculationPolicyRequest} from '../../models/api/register-calculation-policy-request.model';

export namespace CalculationPolicyEditActions {
    export class SetCalculationData {
        static readonly type = 'CalculationPolicyEditActions.SetCalculationData';

        constructor(public originalCalculation?: Calculation) {}
    }

    export class Save {
        static readonly type = 'CalculationPolicyEditActions.Save';

        constructor(public request?: RegisterCalculationPolicyRequest, public productCode?: string) {}
    }
}
